import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRoute = '/operation/sales';

@Injectable({
  providedIn: 'root'
})
export class SalesService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }
}
